import React, { FC } from 'react'
import { Progress } from '@chakra-ui/progress'
import { useSelector } from 'react-redux'
import { selectProgressState } from '../../state'

export const ScenarioProgressBar: FC = () => {
  const progressState = useSelector(selectProgressState)

  return <Progress value={!progressState ? 0 : progressState} size="xs" colorScheme="green" />
}
